import React, { Component } from 'react';
import { connect } from 'react-redux';
import { API, Auth } from 'aws-amplify';
import { Button, Layout, Row, Steps, InputNumber, Col, Spin, Select, Table } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

import InventoryTransactionTicket from '../../../components/UI/Modals/InventoryTransactionTicket/InventoryTransactionTicket';

const { Header, Content } = Layout;
const ButtonGroup = Button.Group
const Step = Steps.Step;
const Option = Select.Option;

const printColumns = [{
    title: 'Artículo',
    dataIndex: 'item'
}, {
    title: 'Cantidad surtida',
    dataIndex: 'suppliedQuantity'
}, {
    title: 'Cantidad final en inventario',
    dataIndex: 'inventoryQuantity'
}];


class Supply extends Component {
    state = {
        loadingStepOne: false,
        loadingStepTwo: false,
        loadingStepThree: false,
        loadingSupply: false,
        currentStep: 0,
        inventoryItems: [],
        itemIds: new Map(),
        selectedItems: [],
        tableItems: [],
        suppliedItems: new Map(),
        suppliedItemsNames: new Map(),
        suppliedAmounts: new Map(),
        source: 0,
        sourceQtys: new Map(),
        disableSupplyButton: true,
        transactionTicket: false,
        transactionTicketItems: [],
        ticketHotel: '',
        ticketInventory: ''
    };

    loadData() {
        this.setState({loadingStepOne: true});

        API.get('benackoAPI', '/v2/inventory-items?inventoryId=' + this.props.match.params.id, {
                headers: {
                    Authorization: this.idToken
                }
            })
            .then( async itemsRes => {
                var items = [];
                var itemIds = new Map();

                itemsRes.forEach(async item => {
                    items.push(<Option key={item.id}>{item.name}</Option>);
                    itemIds.set(item.id, item.itemId);
                });

                this.setState({inventoryItems: items, itemIds: itemIds, loadingStepOne: false});
            })
            .catch( errInventoryItems => {
                console.log('Error loading inventory items: ', errInventoryItems);
                this.setState({ loadingStepOne: false });
            });

        API.get('benackoAPI', '/inventories/' + this.props.match.params.id, {
                headers: {
                    Authorization: this.idToken
                }
            })
            .then( inventoryRes => {
                this.setState({
                    source: inventoryRes[0].sourceInventoryId,
                    ticketHotel: this.props.hotels[inventoryRes[0].hotelId],
                    ticketInventory: inventoryRes[0].name,
                    loadingStepOne: false
                });
            })
            .catch( errInventory => {
                console.log('Error loading inventory: ', errInventory);
                this.setState({ loadingStepOne: false });
            });
    }

    async getItemName(itemId) {
        let item = await API.get('benackoAPI', '/items/' + itemId, { headers: { Authorization: this.idToken } });
        let itemName = item[0].name;

        return itemName;
    }

    async getItemCurrentQuantity(inventoryItemId) {
        let item = await API.get('benackoAPI', '/inventory-items/' + inventoryItemId, { headers: { Authorization: this.idToken } });
        let itemQty = item[0].quantity;

        return itemQty;
    }

    async getInventoryItemItemName(inventoryItemId) {
        let item = await API.get('benackoAPI', '/inventory-items/' + inventoryItemId, { headers: { Authorization: this.idToken } });
        let itemName = await this.getItemName(item[0].itemId);

        return itemName;
    }

    async getInventoryItemItemKey(inventoryItemId) {
        let item = await API.get('benackoAPI', '/inventory-items/' + inventoryItemId, { headers: { Authorization: this.idToken } });
        let itemId = item[0].itemId;

        return itemId;
    }

    async getInventoryItemSourceQuantity(sourceInventoryId, inventoryItemId) {
        const itemSourceQuantity = API.get('benackoAPI', '/inventory-items?inventoryId=' + sourceInventoryId, {
                headers: {
                    Authorization: this.idToken
                }
            })
            .then( itemsRes => {
                const item = itemsRes.find( rt => rt.itemId === inventoryItemId );

                return item.quantity;
            })
            .catch( errInventoryItems => {
                console.log('Error loading inventory items: ', errInventoryItems);
            });


        return itemSourceQuantity;
    }

    async getSourceInventoryItemKey(sourceInventoryId, itemId) {
        const inventoryItemKey = API.get('benackoAPI', '/inventory-items?inventoryId=' + sourceInventoryId, {
                headers: {
                    Authorization: this.idToken
                }
            })
            .then( itemsRes => {
                const item = itemsRes.find( rt => rt.itemId === itemId );

                return item.id;
            })
            .catch( errInventoryItems => {
                console.log('Error loading inventory items: ', errInventoryItems);
            });

        return inventoryItemKey;
    }

    componentDidMount() {
        Auth.currentSession()
            .then( response => {
                this.idToken = response.idToken.jwtToken;

                this.loadData();
            })
            .catch( error => {
                console.log(error);
            });
    }

    clearSupplyMap = () => {
        const myMap = new Map();
        myMap.clear();

        const myNamesMap = new Map();
        myNamesMap.clear();

        const suppliedMap = new Map();
        suppliedMap.clear();

        this.setState({suppliedItems: myMap, suppliedItemsNames: myNamesMap, suppliedAmounts: suppliedMap});
    }

    clearSourceMap = () => {
        const sourceMap = new Map();
        sourceMap.clear();

        this.setState({sourceQtys: sourceMap});
    }

    goBackHandler = () => {
        this.props.history.goBack();
    }

    selectItemHandler = (value) => {
        this.setState({selectedItems: value});
    }

    goToSecondStep = async () => {
        this.setState({loadingStepTwo: true, loadingSupply: true});

        const items = await Promise.all(
            this.state.selectedItems.map( async item => {
                const itemKey = item.toString();
                const itemQty = await this.getItemCurrentQuantity(item);
                const itemName = await this.getInventoryItemItemName(item);
                const sourceItemKey = await this.getInventoryItemItemKey(item);
                
                let itemSourceQty = 0;
                if (this.state.source !== 0) {
                    itemSourceQty = await this.getInventoryItemSourceQuantity(this.state.source, sourceItemKey);
                    this.updateSourceQuantityHandler(itemSourceQty, itemKey);
                }
                // NEXT STEP IS TO SUPPLY ITEM, SUBSTRACT FROM SOURCE INVENTORY, AND REGISTER SUPPLY ACTION
                return (
                    <Row key={itemKey} style={{width: '100%', marginTop: 10}}>
                        <Col span={6} offset={2}>{itemName}</Col>
                        <Col span={4}>{itemQty}</Col>
                        <Col span={6}>
                            <InputNumber
                                key={itemKey}
                                defaultValue="0"
                                step={1}
                                min={0}
                                onChange={(e) => {

                                    if (this.state.source !== 0) {
                                        const srcQty = this.state.sourceQtys.get(itemKey);

                                        this.updateSupplyQuantityHandler(e + itemQty, itemKey, itemName, e);

                                        (srcQty < e || e === '' || e < 0 || isNaN(e)) ? this.setState({disableSupplyButton: true}) : this.setState({disableSupplyButton: false});
                                    } else {
                                        (e === '' || e < 0 || isNaN(e)) ? this.setState({disableSupplyButton: true}) : this.setState({disableSupplyButton: false});
                                        this.updateSupplyQuantityHandler(e + itemQty, itemKey, itemName, e);
                                    }
                                }}
                            />
                        </Col>
                        {this.state.source !== 'nil' ? <Col span={4}>{itemSourceQty}</Col> : null}
                    </Row>
                );
            })
        );
        
        this.setState({tableItems: items, currentStep: 1, loadingStepTwo: false, loadingSupply: false});
    }

    updateSupplyQuantityHandler = (value, key, name, suppliedAmount) => {
        var supplyMap = this.state.suppliedItems;
        supplyMap.set(key, value);

        var namesMap = this.state.suppliedItemsNames;
        namesMap.set(key, name);

        var amountsMap = this.state.suppliedAmounts;
        amountsMap.set(key, suppliedAmount);

        this.setState({suppliedItems: supplyMap, suppliedItemsNames: namesMap, suppliedAmounts: amountsMap});
    }

    updateSourceQuantityHandler = (value, key) => {
        var sourceMap = this.state.sourceQtys;
        sourceMap.set(key, value);

        this.setState({sourceQtys: sourceMap});
    }

    goPreviousStep = () => {
        this.clearSupplyMap();

        const newStep = this.state.currentStep - 1;
        this.setState({currentStep: newStep});
    }

    supplyInventory = async (event) => {
        event.preventDefault();

        this.setState({loadingStepThree: true, loadingSupply: true});
        
        var transactionTicketItems = [];
        for (const item of this.state.suppliedItems) {
            transactionTicketItems.push({
                key: item[0],
                item: this.state.suppliedItemsNames.get(item[0]),
                suppliedQuantity: this.state.suppliedAmounts.get(item[0]),
                inventoryQuantity: parseInt(item[1], 10)
            });

            const currentQty = await this.getItemCurrentQuantity(item[0]);
            //const suppliedQty = item[1] - currentQty;
            const supplyFlag = (this.state.source !== 0) ? true : false;

            await API.put('benackoAPI','/inventory-items/' + item[0], {
                body: {
                    quantity: parseInt(item[1], 10),
                    supplyFlag: supplyFlag
                },
                headers: {
                    Authorization: this.idToken
                }
            })
            .then(() => {
                const inventoryAction = {
                    inventoryId: parseInt(this.props.match.params.id, 10),
                    action: 'surtir artículo',
                    itemId: this.state.itemIds.get((parseInt(item[0], 10))),
                    itemName: this.state.suppliedItemsNames.get(item[0]),
                    quantity: this.state.suppliedAmounts.get(item[0]),
                    user: this.props.username,
                    descr: '-'
                };

                API.post('benackoAPI', '/v2/inventory-actions', {
                        body: inventoryAction
                    })
                    .catch(errInvAction => {
                        console.log('Error loading inventory action:', errInvAction);
                        this.setState({loading: false});
                    });
            })
            .then(async () => {
                if (this.state.source !== 0) {
                    const sourceItemKey = await this.getInventoryItemItemKey(item[0]);
                    const sourceInventoryItemKey = await this.getSourceInventoryItemKey(this.state.source, sourceItemKey);
                    const itemSourceQty = await this.getInventoryItemSourceQuantity(this.state.source, sourceItemKey);
                    const retrievedQty = item[1] - currentQty;

                    await API.put('benackoAPI', '/inventory-items/' + sourceInventoryItemKey, {
                        body: {
                            quantity: parseInt(itemSourceQty - retrievedQty, 10),
                            supplyFlag: false
                        },
                        headers: {
                            Authorization: this.idToken
                        }
                    })
                    .then(() => {
                        const inventoryAction = {
                            inventoryId: parseInt(this.state.source, 10),
                            action: 'salida de surtido',
                            itemId: this.state.itemIds.get((parseInt(item[0], 10))),
                            itemName: this.state.suppliedItemsNames.get(item[0]),
                            quantity: this.state.suppliedAmounts.get(item[0]),
                            user: this.props.username,
                            descr: '-'
                        };
        
                        API.post('benackoAPI', '/v2/inventory-actions', {
                                body: inventoryAction
                            })
                            .catch(errInvAction => {
                                console.log('Error loading inventory action:', errInvAction);
                                this.setState({loading: false});
                            });
                    })
                    .catch( error => {
                        console.log(error);
                        this.setState({loading: false});
                    });
                }
            })
            .catch(function (error) {
                this.setState({loading: false});
                console.log(error);
            });
        }

        this.setState({loadingSupply: false, loadingStepThree: false, currentStep: 2, transactionTicketItems: transactionTicketItems});
    }

    goToInventoriesComponent = () => {
        this.props.history.goBack();
    }

    printTransactionTicket = () => {
        this.setState({
            transactionTicket: true
        });
    }

    closeTransactionTicket = () => {
        this.setState({
            transactionTicket: false
        });
    }

    render() {
        const stepOne = (
            <Spin spinning={this.state.loadingStepOne} size="large">
                <Row style={{width: 600}}>
                    <Select
                        mode="multiple"
                        style={{width: '100%'}}
                        placeholder="Selecciona artículos a surtir"
                        onChange={this.selectItemHandler}
                    >
                        {this.state.inventoryItems}
                    </Select>
                </Row>
                <Row style={{marginTop: 20}}>
                    <Button type="primary" onClick={this.goToSecondStep} disabled={(this.state.selectedItems.length <= 0) ? true : false}>Siguiente</Button>
                </Row>
            </Spin>
        );

        const stepTwo = (
            <Spin spinning={this.state.loadingStepTwo} size="large">
                <Row style={{width: 600, marginBottom: 20}}>
                    <Col span={6} offset={2}><strong>Artículo</strong></Col>
                    <Col span={4}><strong>Cantidad actual</strong></Col>
                    <Col span={6}><strong>Cantidad a surtir</strong></Col>
                    {this.state.source !== 'nil' ? <Col span={4}><strong>Cantidad en inventario fuente</strong></Col> : null}
                </Row>
                <Row style={{width: 600}}>
                    {this.state.tableItems}
                </Row>
                <Row style={{marginTop: 40}}>
                    <ButtonGroup>
                        <Button type="primary" onClick={this.goPreviousStep}>Regresar</Button>
                        <Button type="default" onClick={this.supplyInventory} disabled={this.state.disableSupplyButton}>Surtir</Button>
                    </ButtonGroup>
                </Row>
            </Spin>
        );

        const transactionItemsTable = (
            <Table
                columns={printColumns}
                dataSource={this.state.transactionTicketItems}
                size="large"
                pagination={false}
            />
        );

        const stepThree = (
            <Spin spinning={this.state.loadingStepThree} size="large">
                <Row>
                    {transactionItemsTable}
                </Row>
                <Row style={{ marginTop: 40 }}>
                    <ButtonGroup>
                        <Button type="primary" onClick={this.goToInventoriesComponent}>Ir a inventario</Button>
                        <Button type="default" onClick={this.printTransactionTicket}>Imprimir comprobante de transacción</Button>
                    </ButtonGroup>
                </Row>

                <InventoryTransactionTicket
                    visible={this.state.transactionTicket}
                    onCancel={this.closeTransactionTicket}
                    transactionTitle="Surtido de inventario"
                    transactionItems={transactionItemsTable}
                    hotel={this.state.ticketHotel}
                    inventory={this.state.ticketInventory}
                    user={this.props.username}
                />
            </Spin>
        );

        let renderedStep = null;
        if (this.state.currentStep === 0) {
            renderedStep = stepOne;
        }

        if (this.state.currentStep === 1) {
            renderedStep = stepTwo;
        }

        if (this.state.currentStep === 2) {
            renderedStep = stepThree;
        }
        
        return (
            <Layout>
                <Header style={{ background: '#fff', padding: 0 }}>
                    <Row>
                        <ButtonGroup>
                            <Button type="primary" onClick={this.goBackHandler}>
                                <LeftOutlined />Regresar
                            </Button>
                        </ButtonGroup>
                    </Row>
                </Header>
                <Content style={{width: '100%', margin: 0, padding: 0, background: '#ffff', paddingTop: 15, paddingLeft: 20}}>
                    <Steps size="small" current={this.state.currentStep}>
                        <Step title="Seleccionar" />
                        <Step title="Surtir" />
                        <Step title="Comprobante" />
                    </Steps>
                    <Row style={{width: '100%', marginTop: 50}}>
                        <Spin spinning={this.state.loadingSupply} size="large">
                        <Col span={20} offset={2}>
                            {renderedStep}
                        </Col>
                        </Spin>
                    </Row>
                </Content>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        username: state.auth.user.username,
        hotels: state.auth.hotels
    };
};


export default connect(mapStateToProps, null)(Supply);